import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import { EncrdecrService } from '../../Auth/encrdecr.service';
import * as fs from 'file-saver';
import { DefaultCompanyLogoBs64 } from '../../validation';
import * as logoFile from './../../../assets/logo.js';
import { DatePipe } from '@angular/common';
import { ClientDataService } from '../client-data.service';
@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  
  myDate = new Date();
  todaysDate = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
  CompanyLogoBs64: any;
  constructor(private EncrdecrService: EncrdecrService, private datePipe: DatePipe, private cds: ClientDataService) {
    //////////
  }
  generateClientsExcel(ExcelData: any, ExcelName: string, ExcelHeader: any[], ReportMainHeading: string) {
    ////////
    debugger
    this.CompanyLogoBs64 = '';
    if (this.CompanyLogoBs64 == '') {
      this.CompanyLogoBs64 = DefaultCompanyLogoBs64;//;
    }

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(ExcelName, { properties: { tabColor: { argb: '4285f4' } }, views: [{ showGridLines: true }] })
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    // let logo = workbook.addImage({
    //   base64: this.CompanyLogoBs64,
    //   extension: 'png',
    // });
    // worksheet.addImage(logo, 'A2:B5');
    let logo = workbook.addImage({
      base64: this.CompanyLogoBs64,
      extension: 'png',
    });
    if (this.cds.GetCompanyName() === 'Mahindra') {
      worksheet.addImage(logo, 'A2:B3');
    } else {
      worksheet.addImage(logo, 'A2:B5');
    }
    worksheet.addRow([]);

    let test: any = [ReportMainHeading]
    let ReportHeading = worksheet.addRow(test);
    ReportHeading.font = { bold: true, size: 14 }
    worksheet.addRow([]);

    let headerRow = worksheet.addRow(ExcelHeader);

    headerRow.font = {
      //name: 'Calibri',
      //size: 16,
      //underline: 'single',
      bold: true,
      color: { argb: 'ffffff' }
    }

    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '6d6e72' },
        //bgColor: { argb: 'ffffff' }
      }

      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });

    ExcelData.map(arr => {
      let DataRow = worksheet.addRow(arr);
      //DataRow.eachCell((cell, number) => {
      //  cell.border = {
      //    top: { style: 'thin', color: {argb:'cccccc'}},
      //    left: { style: 'thin', color: {argb:'cccccc'}},
      //    bottom: { style: 'thin', color: {argb:'cccccc'}},
      //    right: { style: 'thin', color: {argb:'cccccc'}}
      //  }
      //});
    });

    worksheet.getColumn(2).width = 15;
    worksheet.getColumn(3).width = 15;
    worksheet.getColumn(4).width = 18;
    worksheet.getColumn(5).width = 35;
    worksheet.getColumn(6).width = 25;
    worksheet.getColumn(7).width = 25;
    worksheet.getColumn(8).width = 25;
    worksheet.getColumn(9).width = 15;
    worksheet.getColumn(10).width = 15;

    worksheet.addRow([]);

    let desclaimer: any[] = ['Disclaimer :'];
    let bottomRow = worksheet.addRow(desclaimer);
    bottomRow.font = { bold: true };
    let desclaimer1: any[] = [
      "This Statement/Report has been prepared based on the information available with Incred Markets and/or the data provided by the Registrar and Transfer Agents (RTAs), AMCs, Issuers, Companies, any other external agencies, etc. which InCred believes to be reliable.The incorrect or insufficient data received from the above sources may lead to incomplete/inaccurate Statement/Report.  The data in this Statement/Report, including but not limited to NAVs, is subject to revision/rectification by InCred/ RTA / AMC/Issuers/Companies, etc. at any point of time.",
    ];
    let desclaimer2: any[] = [
      "InCred reserves the right to update the Statement/Report at such frequency as it may deem fit and also reserves the right to amend and/or rectify the discrepancies, if any, in this Statement/Report at any time without assigning any reason whatsoever. As a result of such revision/rectification, the data made available in this Statement/Report prior to such rectification/revision may undergo change.",
    ];
    let desclaimer3: any[] = [
      "The above Statement/Report is not available on a real time basis. InCred or any of its directors, employees or agents take no responsibility for any inaccuracy or incompleteness in this Statement/Report. For taking any investment decision including, but not limited to, redemptions and switches, Independent Financial Distributor (MA)/investor is requested to always refer/rely on the Statement of Account provided by AMC/Registrars.",
    ];
    let desclaimer4: any[] = [
      "Note: 1. For Mutual Fund (MF), this statement summarises total holdings at scheme & folio level for your client, based on transactional data available from AMCs/RTAs as on report generation date. 2. Latest available NAV is taken for the purpose of showing as on date valuation. For NAV=0 or for a blank NAV, the last reported NAV will be considered. 3. Actual Cost of balance units in a scheme for a folio= (Number of balance units) x (Purchase NAV). There could be a minor difference in the Cost to the extent of Entry load on transactions prior to 1st August 2009 and having balance units as on report date. 4. The actual profit/loss values in this statement contains Dividend, hence it may not exactly match with the values in Capital Gain/Loss statement.",
    ];
    let bottomRow1 = worksheet.addRow(desclaimer1);
    let bottomRow2 = worksheet.addRow(desclaimer2);
    let bottomRow3 = worksheet.addRow(desclaimer3);
    let bottomRow4 = worksheet.addRow(desclaimer4);
    bottomRow1.font = { bold: true };
    bottomRow2.font = { bold: true };
    bottomRow3.font = { bold: true };
    bottomRow4.font = { bold: true };

    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //fs.saveAs(blob, `${ExcelName}.xlsx`);//commented by Rohan on 31/07/2025
      ////// Added by Rohan on 31/07/2025
      this.ConvertBlobToBase64(blob, `${ExcelName}.xlsx`);
      ///// END
    });
  }


  generateMultipleExcelSheet(ExcelWorkbookName, ExcelData: any[], ExcelName: any[], ExcelHeader: any[]) {
    let workbook = new Workbook();
    let worksheet;
    this.CompanyLogoBs64 = '';
    //#region - Dynamic Logo Logic for Corporate and IFA
    // let Flag = sessionStorage.getItem("Vbhs@#%LMKIo="); //Flag > C = Corporate | I = IFA
    // if (Flag != null && Flag != "" && Flag != undefined) {
    //   if (Flag === "C") {
    //     switch (this.cds.GetCompanyName()) {

    //       default:
    //         this.CompanyLogoBs64 = DefaultCompanyLogoBs64;
    //         break;
    //     }
    //   } else {

    //   }
    // }

    this.CompanyLogoBs64 = '';
    if (this.CompanyLogoBs64 == '') {
      this.CompanyLogoBs64 = DefaultCompanyLogoBs64;//;
    }
    //#endregion

    ////////
    for (let i = 0; i < ExcelName.length; i++) {
      worksheet = workbook.addWorksheet(`${ExcelName[i]}`);
      worksheet.addRow([]);
      worksheet.addRow([]);
      worksheet.addRow([]);
      worksheet.addRow([]);
      worksheet.addRow([]);
      worksheet.addRow([]);
      let logo = workbook.addImage({
        base64: this.CompanyLogoBs64,
        extension: 'png',
      });
      worksheet.addImage(logo, 'A2:B5');
      worksheet.addRow([]);

      let headerRow = worksheet.addRow(ExcelHeader[i]);
      headerRow.font = { bold: true };

      headerRow.eachCell((cell, number) => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });

      ExcelData[i].map(arr => {

        if ((arr[arr.length - 1]) === "headerrow") {
          arr.pop();
          let headerRow1 = worksheet.addRow(arr);
          headerRow1.font = { bold: true };

          headerRow1.eachCell((cell, number) => {
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
          })
        }
        else if ((arr[arr.length - 1]) === "headding") {
          arr.pop();
          let headerRow1 = worksheet.addRow(arr);
          headerRow1.font = { bold: true };

        }
        else {
          worksheet.addRow(arr);
        }
      });

      worksheet.getColumn(2).width = 15;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 18;
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 25;
      worksheet.getColumn(9).width = 15;
      worksheet.getColumn(10).width = 15;

      worksheet.addRow([]);
    }

    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //fs.saveAs(blob, `${ExcelWorkbookName}.xlsx`);//commented by Rohan on 31/07/2025
      ////// Added by Rohan on 31/07/2025
      this.ConvertBlobToBase64(blob, `${ExcelWorkbookName}.xlsx`);
      ///// END
    });
  }


  generateMultipleTabInOneExcelSheet(ExcelWorkbookName, ReportMainHeading, MainHeading, ExcelName: any[], ExcelHeader: any[], ExcelData: any[],option:boolean = false, autoFitColumns: boolean = false) {
    debugger
    //var Excel = require('exceljs');
    //debugger;
    let workbook = new Workbook();
    let worksheet;
    // row numbers of the table (header + data) rows only - used by the auto fit below so that
    // the report heading and the disclaimer paragraphs never decide a column width
    let tableRowNumbers: number[] = [];
    const leftAlignColumns = [
      'Investor Name', 'Pan No', 'Holding Type', 'Category Name',
      'Scheme Name', 'Folio no', 'SIP', 'STP', 'SWP',
      'Tranx. Type', 'Trnx. Type', 'Transaction Type', 'Tranx. Nature / Remarks',
      'Rejection Remark', 'Online Flag', 'SchemeName', 'Address1', 'Address2', 'Address3', 'City',
      'Pin', 'Folio Number', 'Live AUM', 'SIP Registration No.', 'Details', 'PAN', 'Bounce Reason',
      'SecondHolderPan', 'FirstHolderPan', 'Frequency', 'Target Scheme', 'Client Name', 'Folio No.', 'Rejection Remark',
      'Online Flag', "Address1", "Address2", "Address3", "City", "MobileDeclaration", "EmailID", "EmailDeclaration", "TaxStatus", "HoldingNature", "SecondHolderName", "SecondHolderPAN", "SecondHolderMobile", "SecondHolderMobile_Declaration",
      "SecondHolderEmail", "SecondHolderEmail_Declaration", "ThirdHolderName", "ThirdHolderPAN", "ThirdHolderMobile", "ThirdHolderMobile_Declaration",
      "ThirdHolderEmail", "ThirdHolderEmail_Declaration", "BankName", "Branch_Name", "BankAccountType", "IFSC", "GuardianPan", "GuardianName",
      "NomineeOptOut", "Nominee1Relationship", "Nominee1DOB", "Nominee1GAURDNAME", "Nominee1GAURDPAN", "Nominee2Name",
      "Nominee2Relationship", "Nominee2DOB", "Nominee2GAURDNAME", "Nominee2GAURDPAN", "Nominee3Name", "Nominee3Relationship", "Nominee3DOB",
      "Nominee3GAURDNAME", "Nominee3GAURDPAN", "Client PAN", "AMC Name", "Asset Class", "Bounce Reason", "SIP ID", "Live AUM", "SIP Status", "ClientCode", "  ", "Purchase Trnx. Type", "Redemption Trnx. Type", "UCC Code",
      "Mode of Holding", "First Holder Name", "First Holder PAN", "Second Holder Name", "Second Holder PAN", "Third Holder Name", "Third Holder PAN",
      "First Holder Consent Status", "Second Holder Consent Status", "Third Holder Consent Status", "UCC Status", "Rejection Reason", "Nominee Details",
      "Client Name/PAN","Registration Date","Due Date","Previous Installment Date","Total Amount Paid","Total Installment Count","FOT","Mandate","Child Subbroker Code",
      "Primary Holder Risk Profile","Company Name","Employee Name","Agent Name","Branch Name","Agent Code","Employee Code","Branch Code", "FDR No", "Client Code"
      , "MutualFund", "Cams Code", "Asset_Type", "Sub_Category", "Trxn_Type_Name", "Sub_TrxnType_Name", "Application_No", "ARNNO", "ClientName", "AgentName", "AgentCode", "EmpName", "EmployeeCode", "BranchName", "BranchCode", "BrokerName", "Tax_Status", "Holding_Type", "ReinvestmentFlag", "SIPFlag","Location","Trxn_Location","EmployeeName"
    ];

    //#region - Dynamic Logo Logic for Corporate and IFA  
    // let Flag = 'C'//sessionStorage.getItem("Vbhs@#%LMKIo="); //Flag > C = Corporate | I = IFA
    // if (Flag != null && Flag != "" && Flag != undefined) {
    //   if (Flag === "C") {

    //     var CompanyName = this.cds.GetCompanyName();
    //     switch (CompanyName) {

    //       default:

    //         break;
    //     }
    //   }
    // }
    //#endregion
    this.CompanyLogoBs64 = DefaultCompanyLogoBs64;
    ////////
    worksheet = workbook.addWorksheet(
      ExcelWorkbookName,
      {
        properties:
        {
          tabColor: { argb: '4285f4' }
        },
        views: [
          {
            showGridLines: true
          }
        ]
      })

    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let logo = workbook.addImage({
      base64: this.CompanyLogoBs64,
      extension: 'png',
    });

    if (autoFitColumns) {
      // A range anchor makes the logo grow with the columns it spans, and the auto fit below
      // widens column A. Pin it to the pixel size the A2:B4 box gave before the auto fit
      // (col A 8.43 + col B 15 = 174px wide, 3 default rows = 60px high) so it stays the same.
      worksheet.addImage(logo, {
        tl: { col: 0, row: 1 },
        ext: { width: 174, height: 60 }
      });
    } else {
      worksheet.addImage(logo, 'A2:B4');
    }


    worksheet.addRow([]);
    //////
    let test: any = [ReportMainHeading]
    let ReportHeading = worksheet.addRow(test);
    ReportHeading.font = { bold: true, size: 14 }
    worksheet.addRow([]);

    for (let j = 0; j < MainHeading.length; j++) {
      //let  mainheading:any[]=[MainHeading[j]];
      let headingRow = worksheet.addRow(MainHeading[j]);
      headingRow.font = { bold: true };

    }

    for (let i = 0; i < ExcelName.length; i++) {
      worksheet.addRow([]);
      //debugger;
      let heading: any[] = [ExcelName[i]];
      let headingRow = worksheet.addRow(heading);
      headingRow.font = { bold: true };
      worksheet.addRow([]);
      let headerRow = worksheet.addRow(ExcelHeader[i]);
      tableRowNumbers.push(headerRow.number);

      headerRow.font = {
        //name: 'Calibri',
        //size: 16,
        //underline: 'single',
        bold: true,
        color: { argb: 'ffffff' }
      }

      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '6d6e72' },
          //bgColor: { argb: 'ffffff' }
        }
        // if (f.includes(ExcelHeader[i][number - 1])) {
        //   cell.alignment = { horizontal: 'left' };
        // } else {
        //   cell.alignment = { horizontal: 'right' };
        // }

 // if (ExcelWorkbookName == "Transaction RTA Wise Report") {
        //   cell.alignment = { horizontal: "left" };
        // }
        // else {

        //   cell.alignment = { horizontal: "center" };
        // }
        cell.alignment = { horizontal: 'center' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });

      ExcelData[i].map(arr => {

        if ((arr[arr.length - 1]) === "Total") {
          arr.pop();
          let totalRow = worksheet.addRow(arr);
          tableRowNumbers.push(totalRow.number);

          totalRow.eachCell((cell, number) => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'e8f0fd' },
              //color: { argb: 'ffffff' }
            },
              cell.font = { bold: true }
            cell.alignment = {
              horizontal: 'right',
            };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
          });
        } else {
          //debugger;
          let DataRow = worksheet.addRow(arr);
          tableRowNumbers.push(DataRow.number);
          DataRow.eachCell((cell, colNumber) => {
            cell.alignment = {
              horizontal: 'right',
            }

            if (leftAlignColumns.includes(ExcelHeader[i][colNumber - 1])) {
              cell.alignment = { horizontal: 'left' };
            } else {
              cell.alignment = { horizontal: 'right' };
            }
          });

          if (option) {
            worksheet.eachRow((row, rowNumber) => {
              // Example: force column 3 to be numeric
              const cell = row.getCell(8); // 1-based index
              if (typeof cell.value === 'string' && cell.value !== '' && !isNaN(Number(cell.value))) {
                cell.value = Number(cell.value);   // convert string → number
                cell.numFmt = '0.00';              // optional formatting
              }
            });
          }
          // After all rows are added

          //DataRow.eachCell((cell, number) => {
          //  cell.border = {
          //    top: { style: 'thin', color: {argb:'cccccc'}},
          //    left: { style: 'thin', color: {argb:'cccccc'}},
          //    bottom: { style: 'thin', color: {argb:'cccccc'}},
          //    right: { style: 'thin', color: {argb:'cccccc'}}
          //  }
          //});
        }
      });

      if (!autoFitColumns) {
        worksheet.getColumn(2).width = 15;
        worksheet.getColumn(3).width = 15;
        worksheet.getColumn(4).width = 18;
        worksheet.getColumn(5).width = 35;
        worksheet.getColumn(6).width = 25;
        worksheet.getColumn(7).width = 25;
        worksheet.getColumn(8).width = 25;
        worksheet.getColumn(9).width = 15;
        worksheet.getColumn(10).width = 15;
        worksheet.getColumn(12).width = 25;
        worksheet.getColumn(13).width = 15;
        worksheet.getColumn(14).width = 15;
        worksheet.getColumn(15).width = 15;
        worksheet.getColumn(16).width = 20;
        worksheet.getColumn(17).width = 20;
      }

      worksheet.addRow([]);
    }

    if (autoFitColumns) {
      this.AutoFitTableColumns(worksheet, tableRowNumbers);
    }

    if (ReportMainHeading != "IFD Summary Report" && ReportMainHeading != "IFD Detailed Report") {
      let desclaimer: any[] = ['Disclaimer :'];
      let bottomRow = worksheet.addRow(desclaimer);
      bottomRow.font = { bold: true };

      let desclaimer1: any[] = [
        "This Statement/Report has been prepared based on the information available with Elite Wealth Limited and/or the data provided by the Registrar and Transfer Agents (RTAs), AMCs, Issuers, Companies, any other external agencies, etc. which Elite  believes to be reliable.The incorrect or insufficient data received from the above sources may lead to incomplete/inaccurate Statement/Report.  The data in this Statement/Report, including but not limited to NAVs, is subject to revision/rectification by Elite/ RTA / AMC/Issuers/Companies, etc. at any point of time.",
      ];
      let desclaimer2: any[] = [
        "Elite reserves the right to update the Statement/Report at such frequency as it may deem fit and also reserves the right to amend and/or rectify the discrepancies, if any, in this Statement/Report at any time without assigning any reason whatsoever. As a result of such revision/rectification, the data made available in this Statement/Report prior to such rectification/revision may undergo change.",
      ];
      let desclaimer3: any[] = [
        "The above Statement/Report is not available on a real time basis. Elite or any of its directors, employees or agents take no responsibility for any inaccuracy or incompleteness in this Statement/Report. For taking any investment decision including, but not limited to, redemptions and switches, Independent Financial Distributor (MA)/investor is requested to always refer/rely on the Statement of Account provided by AMC/Registrars.",
      ];
      let desclaimer4: any[] = [
        "Note: 1. For Mutual Fund (MF), this statement summarises total holdings at scheme & folio level for your client, based on transactional data available from AMCs/RTAs as on report generation date. 2. Latest available NAV is taken for the purpose of showing as on date valuation. For NAV=0 or for a blank NAV, the last reported NAV will be considered. 3. Actual Cost of balance units in a scheme for a folio= (Number of balance units) x (Purchase NAV). There could be a minor difference in the Cost to the extent of Entry load on transactions prior to 1st August 2009 and having balance units as on report date. 4. The actual profit/loss values in this statement contains Dividend, hence it may not exactly match with the values in Capital Gain/Loss statement.",
      ];
      let bottomRow1 = worksheet.addRow(desclaimer1);
      let bottomRow2 = worksheet.addRow(desclaimer2);
      let bottomRow3 = worksheet.addRow(desclaimer3);
      let bottomRow4 = worksheet.addRow(desclaimer4);
      bottomRow1.font = { bold: true };
      bottomRow2.font = { bold: true };
      bottomRow3.font = { bold: true };
      bottomRow4.font = { bold: true };

    }


    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //fs.saveAs(blob, `${ExcelWorkbookName}.xlsx`);//commented by Rohan on 31/07/2025
      ////// Added by Rohan on 31/07/2025
      this.ConvertBlobToBase64(blob, `${ExcelWorkbookName}.xlsx`);
      ///// END
    });

  }

  /**
   * Sizes every column to its widest table cell so the sheet opens with all data visible.
   * Only the rows passed in (table header / data / total rows) are measured - the report
   * heading and the disclaimer paragraphs sit in column A and would otherwise stretch it.
   */
  private AutoFitTableColumns(worksheet: any, tableRowNumbers: number[], minWidth: number = 12, maxWidth: number = 65) {
    if (!tableRowNumbers || tableRowNumbers.length == 0) {
      return;
    }

    let columnWidths: number[] = [];

    tableRowNumbers.forEach(rowNumber => {
      let row = worksheet.getRow(rowNumber);
      row.eachCell({ includeEmpty: false }, (cell: any, colNumber: number) => {
        let text = this.GetCellDisplayText(cell.value);
        if (text.length > (columnWidths[colNumber] || 0)) {
          columnWidths[colNumber] = text.length;
        }
      });
    });

    for (let colNumber = 1; colNumber < columnWidths.length; colNumber++) {
      if (columnWidths[colNumber] == undefined) {
        continue;
      }
      // +2 covers the cell padding excel adds, bold headers need a little more room
      let width = Math.min(Math.max(columnWidths[colNumber] + 2, minWidth), maxWidth);
      worksheet.getColumn(colNumber).width = width;
    }
  }

  private GetCellDisplayText(value: any): string {
    if (value == null || value == undefined) {
      return '';
    }
    if (value instanceof Date) {
      return value.toLocaleDateString();
    }
    if (typeof value == 'object') {
      if (value.richText) {
        return value.richText.map((t: any) => t.text).join('');
      }
      if (value.text) {
        return value.text.toString();
      }
      if (value.result != undefined) {
        return value.result.toString();
      }
      return '';
    }
    return value.toString();
  }

  ss(str: string): string {
    return sessionStorage.getItem(str)
  }
  // async GetHeaderDetails(): Promise<string | null> {
  //   let req = {
  //     "ClientBasicInfoId": !!this.ss('F44sGAGh2xwkpUL') ? this.EncrdecrService.getDecr(this.ss('F44sGAGh2xwkpUL')) : "",
  //     "flag": "MF",
  //     "Sb_Emp_Id": !!this.ss('F44sGAGh2xwkpUL') ? this.EncrdecrService.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL')) : '',
  //     "UserType": !!this.ss('L2D3506kIHSk3E0') ?
  //       parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))) : 0
  //   }
  //   try {
  //     let response = await lastValueFrom(this.ProfileSer.GetClientDetailsPDF(req))
  //     return response;
  //   } catch (error) {
  //     return ''
  //   }

  // }
  //async aditya
  generateExcelSheet(ExcelWorkbookName, ReportMainHeading, MainHeading, ExcelName: any[], ExcelHeader: any[], ExcelData: any[], para = "0", namecode = ["", ""]) {
    debugger;
    let workbook = new Workbook();
    let worksheet;

    this.CompanyLogoBs64 = DefaultCompanyLogoBs64;
    ////////
    worksheet = workbook.addWorksheet(
      ExcelWorkbookName,
      {
        properties:
        {
          tabColor: { argb: '4285f4' }
        },
        views: [
          {
            showGridLines: true
          }
        ]
      })

    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let logo = workbook.addImage({
      base64: this.CompanyLogoBs64,
      extension: 'png',
    });

    worksheet.addImage(logo, 'A2:B4');


    worksheet.addRow([]);
    //////
    debugger
    let test: any = [ReportMainHeading]
    let ReportHeading = worksheet.addRow(test);
    ReportHeading.font = { bold: true, size: 14 }
    worksheet.addRow([]);
    let userType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem("L2D3506kIHSk3E0")));
    userType.toString() == "2" ?
      MainHeading[0]?.pop() : ""
    if (!!this.ss('V4WGROuLLBE6t98')) {
      let label = 'MA/RM Name :';
      if (ReportMainHeading == 'Detailed Brokerage Report' || ReportMainHeading == 'Summary Brokerage Report') {
        label = 'MA Name :'
      }
      let string = label + (/(overall|new)/.test(para) && userType == 1 ?
        namecode[0] : this.EncrdecrService.getDecr(this.ss('V4WGROuLLBE6t98')))
      MainHeading.splice(1, 0, [string]);
    }
    else {
      let label = 'MA/RM Name :';
      if (ReportMainHeading == 'Detailed Brokerage Report' || ReportMainHeading == 'Summary Brokerage Report') {
        label = 'MA Name :'
      }
      let string = label + ""
      MainHeading.splice(1, 0, [string]);
    }
    if (!!this.ss('m5JkoXISmYRAIuY')) {
      let label = 'MA/RM Code :';
      if (ReportMainHeading == 'Detailed Brokerage Report' || ReportMainHeading == 'Summary Brokerage Report') {
        label = 'MA Code :'
      }
      let string = label + (/(overall|new)/.test(para) && userType == 1 ? namecode[1] : this.EncrdecrService.getDecr(this.ss('m5JkoXISmYRAIuY')))
      MainHeading.splice(2, 0, [string]);
    }
    else {
      let label = 'MA/RM Code :';
      if (ReportMainHeading == 'Detailed Brokerage Report' || ReportMainHeading == 'Summary Brokerage Report') {
        label = 'MA Code :'
      }
      let string = label + ""
      MainHeading.splice(2, 0, [string]);
    }


    for (let j = 0; j < MainHeading.length; j++) {
      let headingRow = worksheet.addRow(MainHeading[j]);
      headingRow.font = { bold: true };
    }

    for (let i = 0; i < ExcelName.length; i++) {
      worksheet.addRow([]);
      let heading: any[] = [ExcelName[i]];
      let headingRow = worksheet.addRow(heading);
      headingRow.font = { bold: true };
      worksheet.addRow([]);
      let headerRow = worksheet.addRow(ExcelHeader[i]);

      headerRow.font = {
        //name: 'Calibri',
        //size: 16,
        //underline: 'single',
        bold: true,
        color: { argb: 'ffffff' }
      }
      headerRow.alignment = {
        vertical: 'middle', // vertically center the text
        horizontal: 'center' // horizontally center the text
      };
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '6d6e72' },
        }

        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });
      const dateRegex = /^(?:\d{4}[-_/]\d{1,2}[-_/]\d{1,2}|\d{4}[-_/]\d{2}[-_/]\d{2}T\d{2}:\d{2}:\d{2}|\d{2}[-_/]\d{2}[-_/]\d{4})$/;

      ExcelData[i].map(arr => {

        if ((arr[arr.length - 1]) === "Total") {
          arr.pop();
          let totalRow = worksheet.addRow(arr);

          totalRow.eachCell((cell, number) => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'e8f0fd' },
              //color: { argb: 'ffffff' }
            },
              cell.font = { bold: true }
            cell.alignment = {
              horizontal: 'right',
            };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
          });

        }
        else {
          let DataRow = worksheet.addRow(arr);
          DataRow.eachCell((cell, colNumber) => {
            const isNumeric = this.Isnumaric(String(cell.value));
            const isDate = dateRegex.test(String(cell.value));

            if ((isNumeric || isDate)) {
              // If it's a number or date, align right
              cell.alignment = { horizontal: 'right' };
            } else {
              // Default case for text or other conditions
              cell.alignment = { horizontal: 'left' };
            }
            if ((para == "4" && i === 2 && colNumber === 4) ||
              (para == "overall" && i == 2 && colNumber == 11)) {
              // Special condition for para, i, and colNumber
              cell.alignment = { horizontal: 'right' };
            }
          });

        }

      });
      // Assuming ExcelData[0] is the array containing all rows
      let lastRows = ExcelData[0][ExcelData[0].length - 1]; // Get the last row in ExcelData[0]

      let HavingTotal = lastRows.includes("Total")
      if (HavingTotal) {
        lastRows.forEach((value, index) => {
          // Check if the value is numeric
          if (!isNaN(value)) {
            // Format the numeric value with commas (using Indian style formatting)
            lastRows[index] = Number(value).toLocaleString('en-IN');
          }
        });
        // Assuming you have the last row of data
        let ExcellastRow = worksheet.lastRow; // Get the last row from the worksheet

        ExcellastRow.eachCell((cell) => {
          // Set alignment to left for all cells in the last row
          cell.alignment = { horizontal: 'right' };
        });
      }

      worksheet.getColumn(2).width = 15;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 18;
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 25;
      worksheet.getColumn(9).width = 15;
      worksheet.getColumn(10).width = 15;

      worksheet.addRow([]);
    }

    if (ReportMainHeading != "IFD Summary Report" && ReportMainHeading != "IFD Detailed Report" && ReportMainHeading != 'Summary Brokerage Report' && ReportMainHeading != 'Detailed Brokerage Report') {
      let desclaimer: any[] = ['Disclaimer :'];
      let bottomRow = worksheet.addRow(desclaimer);
      bottomRow.font = { bold: true };

      let desclaimer1: any[] = ['This Statement/Report has been prepared based on the information available with Incred Markets and/or the data provided by the Registrar and Transfer Agents (RTAs), AMCs, Issuers, Companies, any other external agencies, etc. which InCred believes to be reliable.The incorrect or insufficient data received from the above sources may lead to incomplete/inaccurate Statement/Report.  The data in this Statement/Report, including but not limited to NAVs, is subject to revision/rectification by InCred/ RTA / AMC/Issuers/Companies, etc. at any point of time.'];
      let desclaimer2: any[] = ['InCred reserves the right to update the Statement/Report at such frequency as it may deem fit and also reserves the right to amend and/or rectify the discrepancies, if any, in this Statement/Report at any time without assigning any reason whatsoever. As a result of such revision/rectification, the data made available in this Statement/Report prior to such rectification/revision may undergo change.'];
      let desclaimer3: any[] = ['The above Statement/Report is not available on a real time basis. InCred or any of its directors, employees or agents take no responsibility for any inaccuracy or incompleteness in this Statement/Report. For taking any investment decision including, but not limited to, redemptions and switches, Independent Financial Distributor (MA)/investor is requested to always refer/rely on the Statement of Account provided by AMC/Registrars.'];
      let desclaimer4: any[] = ['Note: 1. For Mutual Fund (MF), this statement summarises total holdings at scheme & folio level for your client, based on transactional data available from AMCs/RTAs as on report generation date. 2. Latest available NAV is taken for the purpose of showing as on date valuation. For NAV=0 or for a blank NAV, the last reported NAV will be considered. 3. Actual Cost of balance units in a scheme for a folio= (Number of balance units) x (Purchase NAV). There could be a minor difference in the Cost to the extent of Entry load on transactions prior to 1st August 2009 and having balance units as on report date. 4. The actual profit/loss values in this statement contains Dividend, hence it may not exactly match with the values in Capital Gain/Loss statement.'];
      let bottomRow1 = worksheet.addRow(desclaimer1);
      let bottomRow2 = worksheet.addRow(desclaimer2);
      let bottomRow3 = worksheet.addRow(desclaimer3);
      let bottomRow4 = worksheet.addRow(desclaimer4);
      bottomRow1.font = { bold: true };
      bottomRow2.font = { bold: true };
      bottomRow3.font = { bold: true };
      bottomRow4.font = { bold: true };

    }


    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      //fs.saveAs(blob, `${ExcelWorkbookName}.xlsx`);//commented by Rohan on 31/07/2025
      ////// Added by Rohan on 31/07/2025
      this.ConvertBlobToBase64(blob, `${ExcelWorkbookName}.xlsx`);
      ///// END
    })
  }

  generateMultipleTabInOneExcelSheetIPO(ExcelWorkbookName, ReportMainHeading, MainHeading, ExcelName: any[], ExcelHeader: any[], ExcelData: any[]) {
    //var Excel = require('exceljs');
    let workbook = new Workbook();
    let worksheet;



    //#region - Dynamic Logo Logic for Corporate and IFA
    let Flag = sessionStorage.getItem("Vbhs@#%LMKIo="); //Flag > C = Corporate | I = IFA
    if (Flag != null && Flag != "" && Flag != undefined) {
      if (Flag === "C") {

        var CompanyName = this.cds.GetCompanyName();
        switch (CompanyName) {

          default:
            this.CompanyLogoBs64 = DefaultCompanyLogoBs64;
            break;
        }
      } else {

      }
    }
    //#endregion

    ////////
    worksheet = workbook.addWorksheet(
      ExcelWorkbookName,
      {
        properties:
        {
          tabColor: { argb: '4285f4' }
        },
        views: [
          {
            showGridLines: true
          }
        ]
      })

    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let logo = workbook.addImage({
      base64: this.CompanyLogoBs64,
      extension: 'png',
    });
    if (this.cds.GetCompanyName() === 'Mahindra') {
      worksheet.addImage(logo, 'A2:B3');
    } else {
      worksheet.addImage(logo, 'A2:B5');
    }

    worksheet.addRow([]);
    //////
    let test: any = [ReportMainHeading]
    let ReportHeading = worksheet.addRow(test);
    ReportHeading.font = { bold: true, size: 14 }
    worksheet.addRow([]);

    for (let j = 0; j < MainHeading.length; j++) {
      //let  mainheading:any[]=[MainHeading[j]];
      let headingRow = worksheet.addRow(MainHeading[j]);
      headingRow.font = { bold: true };

    }

    for (let i = 0; i < ExcelName.length; i++) {
      worksheet.addRow([]);
      let heading: any[] = [ExcelName[i]];
      let headingRow = worksheet.addRow(heading);
      headingRow.font = { bold: true };
      worksheet.addRow([]);
      let headerRow = worksheet.addRow(ExcelHeader[i]);

      headerRow.font = {
        //name: 'Calibri',
        //size: 16,
        //underline: 'single',
        bold: true,
        color: { argb: 'ffffff' }
      }

      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '6d6e72' },
          //bgColor: { argb: 'ffffff' }
        }

        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });

      ExcelData[i].map(arr => {

        if ((arr[arr.length - 1]) === "Total") {
          arr.pop();
          let totalRow = worksheet.addRow(arr);

          totalRow.eachCell((cell, number) => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'e8f0fd' },
              //color: { argb: 'ffffff' }
            },
              cell.font = { bold: true }

            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
          });
        }
        else {
          let DataRow = worksheet.addRow(arr);
          //DataRow.eachCell((cell, number) => {
          //  cell.border = {
          //    top: { style: 'thin', color: {argb:'cccccc'}},
          //    left: { style: 'thin', color: {argb:'cccccc'}},
          //    bottom: { style: 'thin', color: {argb:'cccccc'}},
          //    right: { style: 'thin', color: {argb:'cccccc'}}
          //  }
          //});
        }
      });

      worksheet.getColumn(2).width = 15;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 18;
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 25;
      worksheet.getColumn(9).width = 15;
      worksheet.getColumn(10).width = 15;

      worksheet.addRow([]);
    }

    // let desclaimer: any[] = ['Disclaimer :'];
    // let bottomRow = worksheet.addRow(desclaimer);
    // bottomRow.font = { bold: true };

    // let desclaimer1: any[] = ['This statement is based on the information made available to us by the Asset Management Companies (AMC).'];
    // let desclaimer2: any[] = ['To that extent, there may be a delay in updating the latest values in this statement in case of delay in receipt of data from the AMCs.'];
    // let desclaimer3: any[] = ['Hence, the statement from the respective AMC should reflect the exact information for the respective folio. Any discrepancy in the above statement should be reported to us.'];
    // let desclaimer4: any[] = ['The tax calculations are made based on our interpretation of the Income tax Act. Please contact your Accountant/Tax consultant for the exact calculations. Maturity Date, where displayed is based on available information.'];
    // let bottomRow1 = worksheet.addRow(desclaimer1);
    // let bottomRow2 = worksheet.addRow(desclaimer2);
    // let bottomRow3 = worksheet.addRow(desclaimer3);
    // let bottomRow4 = worksheet.addRow(desclaimer4);
    // bottomRow1.font = { bold: true };
    // bottomRow2.font = { bold: true };
    // bottomRow3.font = { bold: true };
    // bottomRow4.font = { bold: true };

    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //fs.saveAs(blob, `${ExcelWorkbookName}.xlsx`);//commented by Rohan on 31/07/2025
      ////// Added by Rohan on 31/07/2025
      this.ConvertBlobToBase64(blob, `${ExcelWorkbookName}.xlsx`);
      ///// END
    });
  }

  generateExcel(ExcelWorkbookName, ReportMainHeading, MainHeading, ExcelName: any[], ExcelHeader: any[], ExcelData: any[]) {
    //var Excel = require('exceljs');
    let workbook = new Workbook();
    let worksheet;



    //#region - Dynamic Logo Logic for Corporate and IFA
    let Flag = sessionStorage.getItem("Vbhs@#%LMKIo="); //Flag > C = Corporate | I = IFA
    if (Flag != null && Flag != "" && Flag != undefined) {
      if (Flag === "C") {
        switch (this.cds.GetCompanyName()) {

          default:
            this.CompanyLogoBs64 = DefaultCompanyLogoBs64;
            break;
        }
      } else {

      }
    }
    //#endregion

    ////////
    worksheet = workbook.addWorksheet(
      ExcelWorkbookName,
      {
        properties:
        {
          tabColor: { argb: '4285f4' }
        },
        views: [
          {
            showGridLines: true
          }
        ]
      })

    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let logo = workbook.addImage({
      base64: this.CompanyLogoBs64,
      extension: 'png',
    });

    if (this.cds.GetCompanyName() === 'Mahindra') {
      worksheet.addImage(logo, 'A2:B3');
    } else {
      worksheet.addImage(logo, 'A2:B5');
    }
    worksheet.addRow([]);
    //////
    let test: any = [ReportMainHeading]
    let ReportHeading = worksheet.addRow(test);
    ReportHeading.font = { bold: true, size: 14 }
    worksheet.addRow([]);

    for (let j = 0; j < MainHeading.length; j++) {
      //let  mainheading:any[]=[MainHeading[j]];
      let headingRow = worksheet.addRow(MainHeading[j]);
      headingRow.font = { bold: true };

    }

    for (let i = 0; i < ExcelName.length; i++) {
      worksheet.addRow([]);
      let heading: any[] = [ExcelName[i]];
      let headingRow = worksheet.addRow(heading);
      headingRow.font = { bold: true };
      worksheet.addRow([]);
      let headerRow = worksheet.addRow(ExcelHeader[i]);

      headerRow.font = {
        //name: 'Calibri',
        //size: 16,
        //underline: 'single',
        bold: true,
        color: { argb: 'ffffff' }
      }

      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '6d6e72' },
          //bgColor: { argb: 'ffffff' }
        }

        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });

      ExcelData[i].map(arr => {

        if ((arr[arr.length - 1]) === "Total") {
          arr.pop();
          let totalRow = worksheet.addRow(arr);

          totalRow.eachCell((cell, number) => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'e8f0fd' },
              //color: { argb: 'ffffff' }
            },
              cell.font = { bold: true }

            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
          });
        }
        else {
          let DataRow = worksheet.addRow(arr);
          //DataRow.eachCell((cell, number) => {
          //  cell.border = {
          //    top: { style: 'thin', color: {argb:'cccccc'}},
          //    left: { style: 'thin', color: {argb:'cccccc'}},
          //    bottom: { style: 'thin', color: {argb:'cccccc'}},
          //    right: { style: 'thin', color: {argb:'cccccc'}}
          //  }
          //});
        }
      });

      worksheet.getColumn(2).width = 15;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 18;
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 25;
      worksheet.getColumn(9).width = 15;
      worksheet.getColumn(10).width = 15;

      worksheet.addRow([]);
    }

    let desclaimer: any[] = ['Disclaimer :'];
    // let bottomRow = worksheet.addRow(desclaimer);
    // bottomRow.font = { bold: true };

    //     let  desclaimer1:any[]=['This statement is based on the information made available to us by the Asset Management Companies (AMC).'];
    //     let  desclaimer2:any[]=['To that extent, there may be a delay in updating the latest values in this statement in case of delay in receipt of data from the AMCs.'];
    //     let  desclaimer3:any[]=['Hence, the statement from the respective AMC should reflect the exact information for the respective folio. Any discrepancy in the above statement should be reported to us.'];
    //     let  desclaimer4:any[]=['The tax calculations are made based on our interpretation of the Income tax Act. Please contact your Accountant/Tax consultant for the exact calculations. Maturity Date, where displayed is based on available information.'];
    // let bottomRow1 = worksheet.addRow(desclaimer1);
    // let bottomRow2 = worksheet.addRow(desclaimer2);
    // let bottomRow3 = worksheet.addRow(desclaimer3);
    // let bottomRow4 = worksheet.addRow(desclaimer4);
    // bottomRow1.font = { bold: true };
    // bottomRow2.font = { bold: true };
    // bottomRow3.font = { bold: true };
    // bottomRow4.font = { bold: true };

    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //fs.saveAs(blob, `${ExcelWorkbookName}.xlsx`);//commented by Rohan on 31/07/2025
      ////// Added by Rohan on 31/07/2025
      this.ConvertBlobToBase64(blob, `${ExcelWorkbookName}.xlsx`);
      ///// END
    });
  }
  genrateExcelWithoutlogoandheader(ExcelWorkbookName, ReportMainHeading, MainHeading, ExcelName: any[], ExcelHeader: any[], ExcelData: any[]) {
    //var Excel = require('exceljs');
    let workbook = new Workbook();
    let worksheet;
    worksheet = workbook.addWorksheet(
      ExcelWorkbookName,
      {
        properties:
        {
          tabColor: { argb: '4285f4' }
        },
        views: [
          {
            showGridLines: true
          }
        ]
      })
    for (let i = 0; i < ExcelName.length; i++) {
      let headerRow = worksheet.addRow(ExcelHeader[i]);
      headerRow.font = {
        //name: 'Calibri',
        //size: 16,
        //underline: 'single',
        bold: true,
        color: { argb: 'ffffff' }
      }
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '6d6e72' },
          //bgColor: { argb: 'ffffff' }
        }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });
      ExcelData[i].map(arr => {
        if ((arr[arr.length - 1]) === "Total") {
          arr.pop();
          let totalRow = worksheet.addRow(arr);
          totalRow.eachCell((cell, number) => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'e8f0fd' },
              //color: { argb: 'ffffff' }
            },
              cell.font = { bold: true }
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
          });
        }
        else {
          let DataRow = worksheet.addRow(arr);
          //DataRow.eachCell((cell, number) => {
          //  cell.border = {
          //    top: { style: 'thin', color: {argb:'cccccc'}},
          //    left: { style: 'thin', color: {argb:'cccccc'}},
          //    bottom: { style: 'thin', color: {argb:'cccccc'}},
          //    right: { style: 'thin', color: {argb:'cccccc'}}
          //  }
          //});
        }
      });
      worksheet.getColumn(2).width = 15;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 18;
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 25;
      worksheet.getColumn(9).width = 15;
      worksheet.getColumn(10).width = 15;
      worksheet.addRow([]);
    }
    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //fs.saveAs(blob, `${ExcelWorkbookName}.xlsx`);//commented by Rohan on 31/07/2025
      ////// Added by Rohan on 31/07/2025
      this.ConvertBlobToBase64(blob, `${ExcelWorkbookName}.xlsx`);
      ///// END
    });
  }

  generateExcelIPO(ExcelWorkbookName, ExcelData: any[], ExcelName: any[], ExcelHeader: any[], ReportMainHeading: string, MainHeading: string) {
    debugger;
    let workbook = new Workbook();
    let worksheet;
    this.CompanyLogoBs64 = '';
    //#region - Dynamic Logo Logic for Corporate and IFA
    // let Flag = sessionStorage.getItem("Vbhs@#%LMKIo="); //Flag > C = Corporate | I = IFA
    // if (Flag != null && Flag != "" && Flag != undefined) {
    //   if (Flag === "C") {
    //     switch (this.cds.GetCompanyName()) {

    //       default:
    //         this.CompanyLogoBs64 = DefaultCompanyLogoBs64;
    //         break;
    //     }
    //   } else {

    //   }
    // }

    this.CompanyLogoBs64 = '';
    if (this.CompanyLogoBs64 == '') {
      this.CompanyLogoBs64 = DefaultCompanyLogoBs64;//;
    }


    ////////
    for (let i = 0; i < ExcelName.length; i++) {
      worksheet = workbook.addWorksheet(`${ExcelName[i]}`);
      worksheet.addRow([]);
      worksheet.addRow([]);
      worksheet.addRow([]);
      worksheet.addRow([]);
      worksheet.addRow([]);
      worksheet.addRow([]);
      let logo = workbook.addImage({
        base64: this.CompanyLogoBs64,
        extension: 'png',
      });
      worksheet.addImage(logo, 'A2:B5');
      worksheet.addRow([]);

      worksheet.addRow([]);

      let test: any = [ReportMainHeading]
      let ReportHeading = worksheet.addRow(test);
      ReportHeading.font = { bold: true, size: 14 }
      worksheet.addRow([]);

      let headerRow = worksheet.addRow(ExcelHeader[i]);
      headerRow.font = { bold: true };



      headerRow.eachCell((cell, number) => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });

      ExcelData[i].map(arr => {

        if ((arr[arr.length - 1]) === "headerrow") {
          arr.pop();
          let headerRow1 = worksheet.addRow(arr);
          headerRow1.font = { bold: true };

          headerRow1.eachCell((cell, number) => {
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
          })
        }
        else if ((arr[arr.length - 1]) === "headding") {
          arr.pop();
          let headerRow1 = worksheet.addRow(arr);

          headerRow1.font = { bold: true };

        }
        else {
          let row = worksheet.addRow(arr);

          row.eachCell((cell, number) => {
            if ([7, 8, 9, 10].includes(number)) {
              // Right-align numeric columns
              cell.alignment = { horizontal: 'right', vertical: 'middle' };
            } else {
              // Left-align text columns
              cell.alignment = { horizontal: 'left', vertical: 'middle' };
            }
          });
        }
      });

      worksheet.getColumn(2).width = 15;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 18;
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 25;
      worksheet.getColumn(9).width = 15;
      worksheet.getColumn(10).width = 15;

      worksheet.addRow([]);
    }



    if (ReportMainHeading != "IFD Summary Report" && ReportMainHeading != "IFD Detailed Report") {
      let desclaimer: any[] = ['Disclaimer :'];
      let bottomRow = worksheet.addRow(desclaimer);
      bottomRow.font = { bold: true };

      let desclaimer1: any[] = [
        "This Statement/Report has been prepared based on the information available with Incred Markets and/or the data provided by the Registrar and Transfer Agents (RTAs), AMCs, Issuers, Companies, any other external agencies, etc. which Incred believes to be reliable.The incorrect or insufficient data received from the above sources may lead to incomplete/inaccurate Statement/Report.  The data in this Statement/Report, including but not limited to NAVs, is subject to revision/rectification by InCred/ RTA / AMC/Issuers/Companies, etc. at any point of time.",
      ];
      let desclaimer2: any[] = [
        "InCred reserves the right to update the Statement/Report at such frequency as it may deem fit and also reserves the right to amend and/or rectify the discrepancies, if any, in this Statement/Report at any time without assigning any reason whatsoever. As a result of such revision/rectification, the data made available in this Statement/Report prior to such rectification/revision may undergo change.",
      ];
      let desclaimer3: any[] = [
        "The above Statement/Report is not available on a real time basis. InCred or any of its directors, employees or agents take no responsibility for any inaccuracy or incompleteness in this Statement/Report. For taking any investment decision including, but not limited to, redemptions and switches, Independent Financial Distributor (MA)/investor is requested to always refer/rely on the Statement of Account provided by AMC/Registrars.",
      ];
      let desclaimer4: any[] = [
        "Note: 1. For Mutual Fund (MF), this statement summarises total holdings at scheme & folio level for your client, based on transactional data available from AMCs/RTAs as on report generation date. 2. Latest available NAV is taken for the purpose of showing as on date valuation. For NAV=0 or for a blank NAV, the last reported NAV will be considered. 3. Actual Cost of balance units in a scheme for a folio= (Number of balance units) x (Purchase NAV). There could be a minor difference in the Cost to the extent of Entry load on transactions prior to 1st August 2009 and having balance units as on report date. 4. The actual profit/loss values in this statement contains Dividend, hence it may not exactly match with the values in Capital Gain/Loss statement.",
      ];
      let bottomRow1 = worksheet.addRow(desclaimer1);
      let bottomRow2 = worksheet.addRow(desclaimer2);
      let bottomRow3 = worksheet.addRow(desclaimer3);
      let bottomRow4 = worksheet.addRow(desclaimer4);
      bottomRow1.font = { bold: true };
      bottomRow2.font = { bold: true };
      bottomRow3.font = { bold: true };
      bottomRow4.font = { bold: true };

    }


    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //fs.saveAs(blob, `${ExcelWorkbookName}.xlsx`);//commented by Rohan on 31/07/2025
      ////// Added by Rohan on 31/07/2025
      this.ConvertBlobToBase64(blob, `${ExcelWorkbookName}.xlsx`);
      ///// END
    });
  }

  ///////
  generateMultipleTabInOneExcelSheet2(ExcelWorkbookName, ReportMainHeading, MainHeading, ExcelName: any[], ExcelHeader: any[], ExcelData: any[]) {
    debugger;
    //var Excel = require('exceljs');
    debugger
    let workbook = new Workbook();
    let worksheet;

    //#region - Dynamic Logo Logic for Corporate and IFA
    // let Flag = 'C'//sessionStorage.getItem("Vbhs@#%LMKIo="); //Flag > C = Corporate | I = IFA
    // if (Flag != null && Flag != "" && Flag != undefined) {
    //   if (Flag === "C") {

    //     var CompanyName = this.cds.GetCompanyName();
    //     switch (CompanyName) {

    //       default:

    //         break;
    //     }
    //   }
    // }
    //#endregion
    this.CompanyLogoBs64 = DefaultCompanyLogoBs64;
    ////////
    worksheet = workbook.addWorksheet(
      ExcelWorkbookName,
      {
        properties:
        {
          tabColor: { argb: '4285f4' }
        },
        views: [
          {
            showGridLines: true
          }
        ]
      })

    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let logo = workbook.addImage({
      base64: this.CompanyLogoBs64,
      extension: 'png',
    });

    worksheet.addImage(logo, 'A2:B4');


    worksheet.addRow([]);
    //////
    let test: any = [ReportMainHeading]
    let ReportHeading = worksheet.addRow(test);
    ReportHeading.font = { bold: true, size: 14 }
    worksheet.addRow([]);

    for (let j = 0; j < MainHeading.length; j++) {
      //let  mainheading:any[]=[MainHeading[j]];
      let headingRow = worksheet.addRow(MainHeading[j]);
      headingRow.font = { bold: true };

    }

    for (let i = 0; i < ExcelName.length; i++) {
      worksheet.addRow([]);
      let heading: any[] = [ExcelName[i]];
      let headingRow = worksheet.addRow(heading);
      headingRow.font = { bold: true };
      worksheet.addRow([]);
      let headerRow = worksheet.addRow(ExcelHeader[i]);

      headerRow.font = {
        //name: 'Calibri',
        //size: 16,
        //underline: 'single',
        bold: true,
        color: { argb: 'ffffff' }
      }

      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '6d6e72' },
          //bgColor: { argb: 'ffffff' }
        }

        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });

      ExcelData[i].map(arr => {

        if ((arr[arr.length - 1]) === "Total") {
          arr.pop();
          let totalRow = worksheet.addRow(arr);

          totalRow.eachCell((cell, number) => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'e8f0fd' },
              //color: { argb: 'ffffff' }
            },
              cell.font = { bold: true }
            cell.alignment = {
              horizontal: 'right',
            };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
          });
        }
        else {
          let DataRow = worksheet.addRow(arr);
          DataRow.eachCell((cell) => {
            cell.alignment = {
              horizontal: 'left',
            }
          });
          //DataRow.eachCell((cell, number) => {
          //  cell.border = {
          //    top: { style: 'thin', color: {argb:'cccccc'}},
          //    left: { style: 'thin', color: {argb:'cccccc'}},
          //    bottom: { style: 'thin', color: {argb:'cccccc'}},
          //    right: { style: 'thin', color: {argb:'cccccc'}}
          //  }
          //});
        }
      });

      worksheet.getColumn(2).width = 15;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 18;
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 25;
      worksheet.getColumn(9).width = 15;
      worksheet.getColumn(10).width = 15;

      worksheet.addRow([]);

      // Check header and set alignment
      worksheet.columns.forEach(column => {
        if (column.header === 'FD/FI Amount') {
          column.alignment = { horizontal: 'right' };
        } else {
          column.alignment = { horizontal: 'left' };
        }

      })

      if (ReportMainHeading != "IFD Summary Report" && ReportMainHeading != "IFD Detailed Report") {
        let desclaimer: any[] = ['Disclaimer :'];
        let bottomRow = worksheet.addRow(desclaimer);
        bottomRow.font = { bold: true };

        let desclaimer1: any[] = [
          "This Statement/Report has been prepared based on the information available with Incred Markets and/or the data provided by the Registrar and Transfer Agents (RTAs), AMCs, Issuers, Companies, any other external agencies, etc. which InCred believes to be reliable.The incorrect or insufficient data received from the above sources may lead to incomplete/inaccurate Statement/Report.  The data in this Statement/Report, including but not limited to NAVs, is subject to revision/rectification by InCred/ RTA / AMC/Issuers/Companies, etc. at any point of time.",
        ];
        let desclaimer2: any[] = [
          "InCred reserves the right to update the Statement/Report at such frequency as it may deem fit and also reserves the right to amend and/or rectify the discrepancies, if any, in this Statement/Report at any time without assigning any reason whatsoever. As a result of such revision/rectification, the data made available in this Statement/Report prior to such rectification/revision may undergo change.",
        ];
        let desclaimer3: any[] = [
          "The above Statement/Report is not available on a real time basis. InCred or any of its directors, employees or agents take no responsibility for any inaccuracy or incompleteness in this Statement/Report. For taking any investment decision including, but not limited to, redemptions and switches, Independent Financial Distributor (MA)/investor is requested to always refer/rely on the Statement of Account provided by AMC/Registrars.",
        ];
        let desclaimer4: any[] = [
          "Note: 1. For Mutual Fund (MF), this statement summarises total holdings at scheme & folio level for your client, based on transactional data available from AMCs/RTAs as on report generation date. 2. Latest available NAV is taken for the purpose of showing as on date valuation. For NAV=0 or for a blank NAV, the last reported NAV will be considered. 3. Actual Cost of balance units in a scheme for a folio= (Number of balance units) x (Purchase NAV). There could be a minor difference in the Cost to the extent of Entry load on transactions prior to 1st August 2009 and having balance units as on report date. 4. The actual profit/loss values in this statement contains Dividend, hence it may not exactly match with the values in Capital Gain/Loss statement.",
        ];
        let bottomRow1 = worksheet.addRow(desclaimer1);
        let bottomRow2 = worksheet.addRow(desclaimer2);
        let bottomRow3 = worksheet.addRow(desclaimer3);
        let bottomRow4 = worksheet.addRow(desclaimer4);
        bottomRow1.font = { bold: true };
        bottomRow2.font = { bold: true };
        bottomRow3.font = { bold: true };
        bottomRow4.font = { bold: true };

      }


      workbook.xlsx.writeBuffer().then((ExcelData) => {
        let blob = new Blob([ExcelData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //fs.saveAs(blob, `${ExcelWorkbookName}.xlsx`);//commented by Rohan on 31/07/2025
        ////// Added by Rohan on 31/07/2025
        this.ConvertBlobToBase64(blob, `${ExcelWorkbookName}.xlsx`);
        ///// END
      });
    }
  }

  Isnumaric(str: string): boolean {
    str = str.replace(/,/g, '').trim();
    // Check if the string is empty or contains only whitespace
    if (str.length === 0) {
      return false;
    }
    // Try to convert the string to a number
    const num = Number(str);

    // Check if the conversion resulted in NaN
    return !isNaN(num)
  }


  generateMultipleTabInOneExcelSheet1(ExcelWorkbookName, ReportMainHeading, MainHeading, ExcelName: any[], ExcelHeader: any[], ExcelData: any[]) {
    debugger;
    //var Excel = require('exceljs');
    debugger
    let workbook = new Workbook();
    let worksheet;
    const leftAlignColumns = [
      "FolioNumber"
    ]; 

    const dateRegex = /^(?:\d{4}[-_]\d{1,2}[-_]\d{1,2}|\d{4}[-_]\d{2}[-_]\d{2}T\d{2}:\d{2}:\d{2}|\d{2}[-_/]\d{2}[-_/]\d{4})$/;


    //#region - Dynamic Logo Logic for Corporate and IFA
    // let Flag = 'C'//sessionStorage.getItem("Vbhs@#%LMKIo="); //Flag > C = Corporate | I = IFA
    // if (Flag != null && Flag != "" && Flag != undefined) {
    //   if (Flag === "C") {

    //     var CompanyName = this.cds.GetCompanyName();
    //     switch (CompanyName) {

    //       default:

    //         break;
    //     }
    //   }
    // }
    //#endregion
    this.CompanyLogoBs64 = DefaultCompanyLogoBs64;
    ////////
    worksheet = workbook.addWorksheet(
      ExcelWorkbookName,
      {
        properties:
        {
          tabColor: { argb: '4285f4' }
        },
        views: [
          {
            showGridLines: true
          }
        ]
      })

    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let logo = workbook.addImage({
      base64: this.CompanyLogoBs64,
      extension: 'png',
    });

    worksheet.addImage(logo, 'A2:B4');


    worksheet.addRow([]);
    //////
    let test: any = [ReportMainHeading]
    let ReportHeading = worksheet.addRow(test);
    ReportHeading.font = { bold: true, size: 14 }
    worksheet.addRow([]);

    for (let j = 0; j < MainHeading.length; j++) {
      //let  mainheading:any[]=[MainHeading[j]];
      let headingRow = worksheet.addRow(MainHeading[j]);
      headingRow.font = { bold: true };

    }

    for (let i = 0; i < ExcelName.length; i++) {
      worksheet.addRow([]);
      let heading: any[] = [ExcelName[i]];
      let headingRow = worksheet.addRow(heading);
      headingRow.font = { bold: true };
      worksheet.addRow([]);
      let headerRow = worksheet.addRow(ExcelHeader[i]); 

      headerRow.font = {
        //name: 'Calibri',
        //size: 16,
        //underline: 'single',
        bold: true,
        color: { argb: 'ffffff' }
      }

      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '6d6e72' },
          //bgColor: { argb: 'ffffff' }
        }
        // if (leftAlignColumns.includes(ExcelHeader[i][number - 1])) {
        //   cell.alignment = { horizontal: 'left' };
        // } else {
        //   cell.alignment = { horizontal: 'right' };
        // }  


        cell.alignment = { horizontal: 'center' };


        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });



      ExcelData[i].map(obj => {
        let arr = Object.values(obj); // Extract values from the object
        let newRow = worksheet.addRow(arr);

        newRow.eachCell((cell, colNumber) => {
          let cellValue: any = arr[colNumber - 1];
          let  isDate = dateRegex.test(String(arr[colNumber - 1]));


          if (cellValue === null || cellValue === undefined) {

            cell.alignment = { horizontal: 'center' };
          } else if ((!isNaN(cellValue) && typeof cellValue !== 'boolean') ||  isDate) {

            cell.alignment = { horizontal: 'right' };
          } else if (typeof cellValue === 'string' && cellValue.trim() === "") {

            cell.alignment = { horizontal: 'center' };
          } else {

            cell.alignment = { horizontal: 'left' };
          }

          if (leftAlignColumns.includes(ExcelHeader[i][colNumber - 1])) {
            cell.alignment = { horizontal: 'left' };
          }
        });
      })

      worksheet.getColumn(2).width = 15;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 18;
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 25;
      worksheet.getColumn(9).width = 15;
      worksheet.getColumn(10).width = 15;

      worksheet.addRow([]);
    }

    if (ReportMainHeading != "IFD Summary Report" && ReportMainHeading != "IFD Detailed Report") {
      let desclaimer: any[] = ['Disclaimer :'];
      let bottomRow = worksheet.addRow(desclaimer);
      bottomRow.font = { bold: true };

      let desclaimer1: any[] = [
        "This Statement/Report has been prepared based on the information available with Incred Markets and/or the data provided by the Registrar and Transfer Agents (RTAs), AMCs, Issuers, Companies, any other external agencies, etc. which InCred believes to be reliable.The incorrect or insufficient data received from the above sources may lead to incomplete/inaccurate Statement/Report.  The data in this Statement/Report, including but not limited to NAVs, is subject to revision/rectification by Incred/ RTA / AMC/Issuers/Companies, etc. at any point of time.",
      ];
      let desclaimer2: any[] = [
        "InCred reserves the right to update the Statement/Report at such frequency as it may deem fit and also reserves the right to amend and/or rectify the discrepancies, if any, in this Statement/Report at any time without assigning any reason whatsoever. As a result of such revision/rectification, the data made available in this Statement/Report prior to such rectification/revision may undergo change.",
      ];
      let desclaimer3: any[] = [
        "The above Statement/Report is not available on a real time basis. InCred or any of its directors, employees or agents take no responsibility for any inaccuracy or incompleteness in this Statement/Report. For taking any investment decision including, but not limited to, redemptions and switches, Independent Financial Distributor (MA)/investor is requested to always refer/rely on the Statement of Account provided by AMC/Registrars.",
      ];
      let desclaimer4: any[] = [
        "Note: 1. For Mutual Fund (MF), this statement summarises total holdings at scheme & folio level for your client, based on transactional data available from AMCs/RTAs as on report generation date. 2. Latest available NAV is taken for the purpose of showing as on date valuation. For NAV=0 or for a blank NAV, the last reported NAV will be considered. 3. Actual Cost of balance units in a scheme for a folio= (Number of balance units) x (Purchase NAV). There could be a minor difference in the Cost to the extent of Entry load on transactions prior to 1st August 2009 and having balance units as on report date. 4. The actual profit/loss values in this statement contains Dividend, hence it may not exactly match with the values in Capital Gain/Loss statement.",
      ];
      let bottomRow1 = worksheet.addRow(desclaimer1);
      let bottomRow2 = worksheet.addRow(desclaimer2);
      let bottomRow3 = worksheet.addRow(desclaimer3);
      let bottomRow4 = worksheet.addRow(desclaimer4);
      bottomRow1.font = { bold: true };
      bottomRow2.font = { bold: true };
      bottomRow3.font = { bold: true };
      bottomRow4.font = { bold: true };

    }


    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //fs.saveAs(blob, `${ExcelWorkbookName}.xlsx`);//commented by Rohan on 31/07/2025
      ////// Added by Rohan on 31/07/2025
      this.ConvertBlobToBase64(blob, `${ExcelWorkbookName}.xlsx`);
      ///// END
    });
  }





  //Added By Devang Mehta On 21-03-2025
  generateMultipleTabInOneExcelSheet_WithMultipleTables(ExcelWorkbookName, ReportMainHeading, MainHeading, ExcelName: any[], ExcelHeader: any[], ExcelData: any[],option:boolean = false) {
    debugger;
    //var Excel = require('exceljs');
    debugger
    let workbook = new Workbook();
    let worksheet;
    const leftAlignColumns = [
      'Investor Name', 'Pan No', 'Holding Type', 'Category Name', 'Scheme Name', 'Folio no', 'SIP', 'STP', 'SWP',
      'Tranx. Type', 'Trnx. Type', 'Transaction Type', 'Tranx. Nature / Remarks',
      'Rejection Remark', 'Online Flag', 'SchemeName', 'Address1', 'Address2', 'Address3', 'City', 'Folio Number', 'Live AUM', 'SIP Registration No.', 'Details', 'PAN', 'Bounce Reason',
      'SecondHolderPan', 'FirstHolderPan', 'Frequency', 'Target Scheme', 'Client Name', 'Folio No.', 'Rejection Remark',
      'Online Flag', "Address1", "Address2", "Address3", "City", "Pin", "MobileNo", "MobileDeclaration", "EmailID", "EmailDeclaration", "TaxStatus", "HoldingNature", "SecondHolderName", "SecondHolderPAN", "SecondHolderMobile", "SecondHolderMobile_Declaration",
      "SecondHolderEmail", "SecondHolderEmail_Declaration", "ThirdHolderName", "ThirdHolderPAN", "ThirdHolderMobile", "ThirdHolderMobile_Declaration",
      "ThirdHolderEmail", "ThirdHolderEmail_Declaration", "BankName", "Branch_Name", "BankAccountType", "BankAccountNumber", "IFSC", "GuardianPan", "GuardianName",
      "NomineeOptOut", "Nominee1Relationship", "Nominee1DOB", "Nominee1Percentage", "Nominee1GAURDNAME", "Nominee1GAURDPAN", "Nominee2Name",
      "Nominee2Relationship", "Nominee2DOB", "Nominee2GAURDNAME", "Nominee2GAURDPAN", "Nominee2Percentage", "Nominee3Name", "Nominee3Relationship", "Nominee3DOB",
      "Nominee3GAURDNAME", "Nominee3GAURDPAN", "Nominee3Percentage", "Client PAN", "AMC Name", "Asset Class", "Bounce Reason", "SIP ID", "Live AUM", "Client Code",
      "First Order", "To Scheme", "Fund Status", "Order Status", "BSE Remark", "Payment Mode", "Transaction Date", "Trade Date", "SBCode/EmpCode", "Payment Status", "", "UCC Code",
      "Mode of Holding", "First Holder Name", "First Holder PAN", "Second Holder Name", "Second Holder PAN", "Third Holder Name", "Third Holder PAN",
      "First Holder Consent Status", "Second Holder Consent Status", "Third Holder Consent Status", "UCC Status", "Rejection Reason", "Nominee Details"
    ];

    //#region - Dynamic Logo Logic for Corporate and IFA
    // let Flag = 'C'//sessionStorage.getItem("Vbhs@#%LMKIo="); //Flag > C = Corporate | I = IFA
    // if (Flag != null && Flag != "" && Flag != undefined) {
    //   if (Flag === "C") {

    //     var CompanyName = this.cds.GetCompanyName();
    //     switch (CompanyName) {

    //       default:

    //         break;
    //     }
    //   }
    // }
    //#endregion
    this.CompanyLogoBs64 = DefaultCompanyLogoBs64;
    ////////
    worksheet = workbook.addWorksheet(
      ExcelWorkbookName,
      {
        properties:
        {
          tabColor: { argb: '4285f4' }
        },
        views: [
          {
            showGridLines: true
          }
        ]
      })

    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let logo = workbook.addImage({
      base64: this.CompanyLogoBs64,
      extension: 'png',
    });

    worksheet.addImage(logo, 'A2:B4');


    worksheet.addRow([]);
    //////
    let test: any = [ReportMainHeading]
    let ReportHeading = worksheet.addRow(test);
    ReportHeading.font = { bold: true, size: 14 }
    worksheet.addRow([]);

    for (let j = 0; j < MainHeading.length; j++) {
      //let  mainheading:any[]=[MainHeading[j]];
      let headingRow = worksheet.addRow(MainHeading[j]);
      headingRow.font = { bold: true };

    }

    for (let i = 0; i < ExcelName.length; i++) {
      worksheet.addRow([]);
      debugger
      let heading: any[] = [ExcelName[i]];
      let headingRow = worksheet.addRow(heading);
      headingRow.font = { bold: true };
    }
    for (let i = 0; i < ExcelHeader.length; i++) {
      worksheet.addRow([]);
      let headerRow = worksheet.addRow(ExcelHeader[i]);

      headerRow.font = {
        //name: 'Calibri',
        //size: 16,
        //underline: 'single',
        bold: true,
        color: { argb: 'ffffff' }
      }

      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '6d6e72' },
          //bgColor: { argb: 'ffffff' }
        }
        if (leftAlignColumns.includes(ExcelHeader[i][number - 1])) {
          cell.alignment = { horizontal: 'left' };
        } else {
          cell.alignment = { horizontal: 'right' };
        }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });

      ExcelData[i].map(arr => {

        if ((arr[arr.length - 1]) === "Total") {
          arr.pop();
          let totalRow = worksheet.addRow(arr);

          totalRow.eachCell((cell, number) => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'e8f0fd' },
              //color: { argb: 'ffffff' }
            },
              cell.font = { bold: true }
            cell.alignment = {
              horizontal: 'right',
            };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
          });
        }
        else {
          debugger
          let DataRow = worksheet.addRow(arr);
          DataRow.eachCell((cell, colNumber) => {
            cell.alignment = {
              horizontal: 'right',
            }

            if (leftAlignColumns.includes(ExcelHeader[i][colNumber - 1])) {
              cell.alignment = { horizontal: 'left' };
            } else {
              cell.alignment = { horizontal: 'right' };
            }
          });
          //DataRow.eachCell((cell, number) => {
          //  cell.border = {
          //    top: { style: 'thin', color: {argb:'cccccc'}},
          //    left: { style: 'thin', color: {argb:'cccccc'}},
          //    bottom: { style: 'thin', color: {argb:'cccccc'}},
          //    right: { style: 'thin', color: {argb:'cccccc'}}
          //  }
          //});
        }
      });

      if (option) {
        worksheet.eachRow((row, rowNumber) => {
          // Example: force column 3 to be numeric
          const cell = row.getCell(8); // 1-based index
          if (typeof cell.value === 'string' && cell.value !== '' && !isNaN(Number(cell.value))) {
            cell.value = Number(cell.value);   // convert string → number
            cell.numFmt = '0.00';              // optional formatting
          }
        });
      }

      worksheet.getColumn(2).width = 15;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 18;
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 25;
      worksheet.getColumn(9).width = 15;
      worksheet.getColumn(10).width = 15;

      worksheet.addRow([]);
    }

    if (ReportMainHeading != "IFD Summary Report" && ReportMainHeading != "IFD Detailed Report") {
      let desclaimer: any[] = ['Disclaimer :'];
      let bottomRow = worksheet.addRow(desclaimer);
      bottomRow.font = { bold: true };

      let desclaimer1: any[] = [
        "This Statement/Report has been prepared based on the information available with Incred Markets and/or the data provided by the Registrar and Transfer Agents (RTAs), AMCs, Issuers, Companies, any other external agencies, etc. which InCred believes to be reliable.The incorrect or insufficient data received from the above sources may lead to incomplete/inaccurate Statement/Report.  The data in this Statement/Report, including but not limited to NAVs, is subject to revision/rectification by InCred/ RTA / AMC/Issuers/Companies, etc. at any point of time.",
      ];
      let desclaimer2: any[] = [
        "InCred reserves the right to update the Statement/Report at such frequency as it may deem fit and also reserves the right to amend and/or rectify the discrepancies, if any, in this Statement/Report at any time without assigning any reason whatsoever. As a result of such revision/rectification, the data made available in this Statement/Report prior to such rectification/revision may undergo change.",
      ];
      let desclaimer3: any[] = [
        "The above Statement/Report is not available on a real time basis. InCred or any of its directors, employees or agents take no responsibility for any inaccuracy or incompleteness in this Statement/Report. For taking any investment decision including, but not limited to, redemptions and switches, Independent Financial Distributor (MA)/investor is requested to always refer/rely on the Statement of Account provided by AMC/Registrars.",
      ];
      let desclaimer4: any[] = [
        "Note: 1. For Mutual Fund (MF), this statement summarises total holdings at scheme & folio level for your client, based on transactional data available from AMCs/RTAs as on report generation date. 2. Latest available NAV is taken for the purpose of showing as on date valuation. For NAV=0 or for a blank NAV, the last reported NAV will be considered. 3. Actual Cost of balance units in a scheme for a folio= (Number of balance units) x (Purchase NAV). There could be a minor difference in the Cost to the extent of Entry load on transactions prior to 1st August 2009 and having balance units as on report date. 4. The actual profit/loss values in this statement contains Dividend, hence it may not exactly match with the values in Capital Gain/Loss statement.",
      ];
      let bottomRow1 = worksheet.addRow(desclaimer1);
      let bottomRow2 = worksheet.addRow(desclaimer2);
      let bottomRow3 = worksheet.addRow(desclaimer3);
      let bottomRow4 = worksheet.addRow(desclaimer4);
      bottomRow1.font = { bold: true };
      bottomRow2.font = { bold: true };
      bottomRow3.font = { bold: true };
      bottomRow4.font = { bold: true };

    }


    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      //fs.saveAs(blob, `${ExcelWorkbookName}.xlsx`);//commented by Rohan on 31/07/2025
      ////// Added by Rohan on 31/07/2025
      this.ConvertBlobToBase64(blob, `${ExcelWorkbookName}.xlsx`);
      ///// END
    });
  }
  //End By Devang Mehta

  //Added by Rohan on 31/07/2025
  ConvertBlobToBase64(blob, ExcelName) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = (reader.result as string);
      this.sendFileToNativeApp(base64String, ExcelName);
    };
    reader.readAsDataURL(blob);
  }
  sendFileToNativeApp(base64Data: string, fileName: string): void {
    debugger
    //alert('In sendFileToNativeApp')
    // For Android
    if (window['AndroidNativeInterface'] && typeof window['AndroidNativeInterface'].onDownloadFileReceived === 'function') {
      window['AndroidNativeInterface'].onDownloadFileReceived(base64Data, fileName);
    }
    // For iOS
    else if (window['webkit']?.messageHandlers?.iOSDownloadBridge) {
      let payload = {
        base64Data,
        fileName,
      };
      window['webkit'].messageHandlers.iOSDownloadBridge.postMessage(JSON.stringify(payload));
    }
    else {
      fs.saveAs(base64Data, fileName)
    }
  }
  //End by Rohan
}
